import { render, staticRenderFns } from "./TicketCounterLifetimeResolved.vue?vue&type=template&id=06749c8a&scoped=true&"
import script from "./TicketCounterLifetimeResolved.vue?vue&type=script&lang=js&"
export * from "./TicketCounterLifetimeResolved.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06749c8a",
  null
  
)

export default component.exports